import { render, staticRenderFns } from "./specialProductEditor.vue?vue&type=template&id=0d48a834&scoped=true"
import script from "./specialProductEditor.vue?vue&type=script&lang=js"
export * from "./specialProductEditor.vue?vue&type=script&lang=js"
import style0 from "./specialProductEditor.vue?vue&type=style&index=0&id=0d48a834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48a834",
  null
  
)

export default component.exports